import React from 'react'
import Image from './image'

// Import images
import comingSoon from '../../../static/images/people/coming-soon.jpg'
import comingSoon2 from '../../../static/images/people/coming-soon2.jpg'
import comingSoon3 from '../../../static/images/people/coming-soon3.jpg'
import newComingSoon1 from '../../../static/images/people/new-coming-soon1.jpg'
import newComingSoon2 from '../../../static/images/people/new-coming-soon2.jpg'
import newComingSoon3 from '../../../static/images/people/new-coming-soon3.jpg'
import newComingSoon4 from '../../../static/images/people/new-coming-soon4.jpg'
import newComingSoon5 from '../../../static/images/people/new-coming-soon5.jpg'
import francescaBattistelli from '../../../static/images/people/francesca-battistelli.jpg'
import garyChapman from '../../../static/images/people/gary-chapman.jpg'
import jeremyCamp from '../../../static/images/people/jeremy-camp.jpg'
import karenKingsbury from '../../../static/images/people/karen-kingsbury.jpg'
import macPowell from '../../../static/images/people/mac-powell.jpg'
import matthewWest from '../../../static/images/people/matthew-west.jpg'
import mercyMe from '../../../static/images/people/mercy-me.jpg'
import michaelTait from '../../../static/images/people/michael-tait.jpg'
import newsboys from '../../../static/images/people/newsboys.jpg'
import stevenCurtisChapman from '../../../static/images/people/steven-curtis-chapman.jpg'
import troyTyler from '../../../static/images/people/troy-tyler.jpg'
import jonForeman from '../../../static/images/people/jon-foreman.jpg'
import bobGoff from '../../../static/images/people/bob-goff.jpg'
import adieCamp from '../../../static/images/people/adie-camp.jpg'
import fiveLoveLanguages from '../../../static/images/logos/5-love-languages.png'
import loveDoes from '../../../static/images/logos/love-does.png'
import sacredMarriage from '../../../static/images/logos/sacred-marriage.png'
import grayPinwheel from '../../../static/images/logos/gray-pinwheel.png'
import timTimmons from '../../../static/images/people/tim-timmons.jpg'
import kimWalkerSmith from '../../../static/images/people/kim-walker-smith.jpg'
import garyThomas from '../../../static/images/people/gary-thomas.jpg'
import maxLucado from '../../../static/images/people/max-lucado.jpg'
import markHall from '../../../static/images/people/mark-hall.jpg'
import maryBethChapman from '../../../static/images/people/mary-beth-chapman.jpg'
import adamagee from '../../../static/images/people/adam-agee.jpg'

// Link imported images
const images = {
  '': comingSoon,
  francescabattistelli: francescaBattistelli,
  newcomingsoon1: newComingSoon1,
  newcomingsoon2: newComingSoon2,
  newcomingsoon3: newComingSoon3,
  newcomingsoon4: newComingSoon4,
  newcomingsoon5: newComingSoon5,
  drgarychapman: garyChapman,
  jeremycamp: jeremyCamp,
  karenkingsbury: karenKingsbury,
  thirdday: macPowell,
  matthewwest: matthewWest,
  mercyme: mercyMe,
  michaeltait: michaelTait,
  newsboys: newsboys,
  stevencurtischapman: stevenCurtisChapman,
  troytyler: troyTyler,
  jonforeman: jonForeman,
  bobgoff: bobGoff,
  adiecamp: adieCamp,
  '5-love-languages': fiveLoveLanguages,
  'love-does': loveDoes,
  'sacred-marriage': sacredMarriage,
  'gray-pinwheel': grayPinwheel,
  timtimmons: timTimmons,
  kimwalkersmith: kimWalkerSmith,
  garythomas: garyThomas,
  maxlucado: maxLucado,
  markhall: markHall,
  marybethchapman: maryBethChapman,
}

export default class LineupCard extends React.Component {
  render() {
    const { person } = this.props

    return (
      <div className="card">
        <div className="body">
          <h3>
            <span>{person.nameFirst}</span>
            <span>{person.nameLast}</span>
          </h3>
        </div>
        <div
          className="image circle"
          style={{
            backgroundImage: `url(${images[person.avatar || person.key]})`,
          }}
        />
        {person.book && <Image className="book" src={images[person.book]} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/lineup-card.js